import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MemberService } from 'src/app/services/member.service';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-subscriptions',
  templateUrl: './subscriptions.component.html',
  styleUrls: ['./subscriptions.component.scss']
})
export class SubscriptionsComponent implements OnInit, AfterViewInit {
  public dataSource = new MatTableDataSource<any>([]);
  public loading = true;
  public currentPage = 1;
  public perPage = 25;
  public total = 0;
  public lastPage = 1;
  public columns = ['created_at', 'member', 'email', 'plan', 'status', 'sub_until', 'actions'];
  public filters = { q: '', plan: '', status: '' };
  public plans: any[] = [];

  private filterSubject = new Subject<void>();

  @ViewChild(MatSort, { static: false }) sort: MatSort;

  constructor(private _member: MemberService) {}

  ngOnInit() {
    this.filterSubject.pipe(debounceTime(400)).subscribe(() => {
      this.currentPage = 1;
      this.load();
    });
    this._member.getPlans().subscribe(res => { this.plans = res; });
    this.load();
  }

  ngAfterViewInit() {
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'member': return item.user ? item.user.first_name + ' ' + item.user.last_name : '';
        case 'email': return item.user ? item.user.email : '';
        default: return item[property];
      }
    };
    this.dataSource.sort = this.sort;
  }

  onFilterChange() { this.filterSubject.next(); }

  load() {
    this.loading = true;
    this._member.getSubscriptions(this.currentPage, this.perPage, this.filters).subscribe(res => {
      this.dataSource.data = res.data;
      this.total = res.total;
      this.lastPage = res.last_page;
      this.loading = false;
      setTimeout(() => { this.dataSource.sort = this.sort; });
    });
  }

  prevPage() { if (this.currentPage > 1) { this.currentPage--; this.load(); } }
  nextPage() { if (this.currentPage < this.lastPage) { this.currentPage++; this.load(); } }

  exportCSV() {
    this._member.getSubscriptions(1, 99999, this.filters).subscribe(res => {
      const rows = res.data;
      const headers = ['Date Created', 'First Name', 'Last Name', 'Email', 'Plan', 'Status', 'Valid Until'];
      const csvRows = rows.map(s => [
        s.created_at ? s.created_at.substring(0, 10) : '',
        s.user ? s.user.first_name : '',
        s.user ? s.user.last_name : '',
        s.user ? s.user.email : '',
        s.description || '',
        s.status || '',
        s.sub_until ? s.sub_until.substring(0, 10) : ''
      ].map(v => `"${String(v).replace(/"/g, '""')}"`).join(','));

      const csv = [headers.join(','), ...csvRows].join('\r\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'subscriptions.csv';
      a.click();
      URL.revokeObjectURL(url);
    });
  }
}

